import util from '@bmp-vue/core/api/util'

const controller = 'Nuliquids'
export default Object.assign({}, util.GetCrud(controller, ['getall', 'get', 'put', 'delete']), {
  GetAllNuLiquids: function (dto) {
    return util.Axios.GetAll(controller + '/GetAllNuLiquids', dto)
  },
  GetNuLiquidsPendenteRamificacao: function (dto) {
    return util.Axios.Post(controller + '/pendente-ramificacao-anterior', dto)
  },
})
